import {useCallback, useRef} from 'react';
import {IArticle} from "../types/IArticle";
import {useAppSelector} from "./redux";


export const useGetArticle = (id: number): IArticle | null => {
    const { articles } = useAppSelector(state => state.store);

    return articles[id] || null;
};